import { useRootSelector } from "~redux/hooks";
import { createBrightContextProvider, useBrightContext } from "@poscon/shared-frontend";

export const BrightContextProvider = createBrightContextProvider(() =>
  useRootSelector((state) => state.eram.brightness),
);

export { useBrightContext };
